// **********Dashboard**********
import Dashboard from "views/Dashboard.js";
// **********Accounts**********
import Accounts from "views/Accounts/Accounts.js";
import AllAccounts from "views/Accounts/AllAccounts.js";
import CreateAccount from "views/Accounts/CreateAccount.js";
import TagContact from "views/Accounts/TagContact";
import Details from "views/Accounts/PersonDetails/Details";
// **********Audience**********
import AllAudience from "views/Audience/AllAudience.js";
import ListAudience from "views/Audience/ListAudience.js";
import CreateAudience from "views/Audience/CreateAudience.js";
import AudienceDetails from "views/Audience/AudienceDetails.js";
import PreviewAudience from "views/Audience/PreviewAudience";
// **********Campaign**********
import AllCampaign from "views/Campaign/AllCampaign.js";
import Campaign_Report from "views/Campaign/Campaign_Report";
import CreateCampaign from "views/Campaign/CreateCampaign.js";
// **********Template**********
import AllTemplates from "views/Templates/AllTemplates";
import Assets from "views/Templates/Assets.js";
import Content from "views/Templates/Content.js";
import CreateTemplate from "views/Templates/CreateTemplate.js";
import CreateTemplateInfo from "views/Templates/CreateTemplateInfo";
import selectTemplate from "views/Templates/SelectTemplate";
// **********Workflow**********
import AllWorkflows from "views/Engagement_Builder/AllWorkflows";
import Automationstudio from "views/Engagement_Builder/Automation_studio";
import CreateAutomation from "views/Engagement_Builder/CreateAutomation";
import WorkflowLogs from "views/Engagement_Builder/WorkflowLogs";
import WorkflowReport from "views/Engagement_Builder/WorkflowReport";
// **********Event&Trigger**********
import AllEvents from "views/Event_And_Signals/AllEvents";
import AllTriggers from "views/Event_And_Signals/AllTriggers";
import CreateEvent from "views/Event_And_Signals/CreateEvent";
import createTrigger from "views/Event_And_Signals/createTrigger";
import listEvent from "views/Event_And_Signals/ListEvent";
import SessionsList from "components/eventsReport/SessionsList"
import SessionsUsersList from "components/eventsReport/SessionsUsersList"
import PageViewsList from "components/eventsReport/PageViewsList"
import UtmlBuilder from 'views/Event_And_Signals/UtmBuilder'
import GoalDetails from "views/CustomerJourney/GoalDetails"

// *****************USERS*******************//
import AllUsers from "views/users/AllUsers";
import CreateUser from "views/users/CreateUser";
import Settings from "views/Settings/Settings"
import Configurations from "views/Settings/Configurations"

import AllApps from "views/Settings/Apps/AllApps";
import AppConfigure from "views/Settings/Apps/AppConfigure";

import Deals from "views/Sales/Deals/Deals"
import DealDetails from "views/Sales/Deals/DealDetails"
import Tasks from "views/Sales/Tasks/Tasks"

import MeetCalendar from 'views/Sales/Meetings/Meetings'
import Payment from "views/Settings/Payment";
//handle the public routes
var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    layout: "/admin",
  },

  //***********Routes for accounts***********//
  {
    path: "/accounts/all",
    name: "All Accounts",
    component: AllAccounts,
    layout: "/admin",
  },
  {
    path: "/contact/tagcontact",
    name: "All Accounts",
    component: TagContact,
    layout: "/admin",
  },
  {
    path: "/contact/list",
    name: "Accounts",
    component: Accounts,
    layout: "/admin",
  },
  {
    path: "/contact/add",
    name: "Add Account",
    component: CreateAccount,
    layout: "/admin",
  },
  {
    path: "/contact/details",
    name: "Person Details",
    component: Details,
    layout: "/admin",
  },

  //***********Routes for audience***********//
  {
    path: "/contact/audience/list/:audienceId",
    name: "Audience Detail",
    component: ListAudience,
    layout: "/admin",
  },
  {
    path: "/contact/audience/preview",
    name: "Audience Detail",
    component: PreviewAudience,
    layout: "/admin",
  },
  {
    path: "/audience/all",
    name: "All Audience",
    component: AllAudience,
    layout: "/admin",
  },
  {
    path: "/contact/audience/details",
    name: "All Audience",
    component: AudienceDetails,
    layout: "/admin",
  },
  {
    path: "/contact/audience/create",
    name: "Create Audience",
    component: CreateAudience,
    layout: "/admin",
  },

  //***********Routes for campaign***********//
  {
    path: "/campaign/all",
    name: "Audience Detail",
    component: AllCampaign,
    layout: "/admin",
  },
  {
    path: "/campaign/create",
    name: "Create Campaign",
    component: CreateCampaign,
    layout: "/admin",
  },
  {
    path: "/campaign/:id",
    name: "Campaign Report",
    component: Campaign_Report,
    layout: "/admin",
  },

  //***********Routes for Template***********//
  {
    path: "/templates/content",
    name: "Content",
    component: Content,
    layout: "/admin",
  },
  {
    path: "/templates/create",
    name: "Create Template",
    component: CreateTemplate,
    layout: "/admin",
  },
  {
    path: "/templates/select",
    name: "Create Template",
    component: selectTemplate,
    layout: "/admin",
  },
  {
    path: "/templates/info",
    name: "Info Template",
    component: CreateTemplateInfo,
    layout: "/admin",
  },
  {
    path: "/templates/all_templates",
    name: "All Templates",
    component: AllTemplates,
    layout: "/admin",
  },
  {
    path: "/templates/assets",
    name: "Assets",
    component: Assets,
    layout: "/admin",
  },

  //***********Routes for Workflow***********//
  {
    path: "/workflow/createAutomation",
    name: "Create Automation",
    component: CreateAutomation,
    layout: "/admin",
  },
  {
    path: "/workflow/automationstudio/create",
    name: "Automation",
    component: Automationstudio,
    layout: "/admin",
  },
  {
    path: "/workflow/all_workflows",
    name: "Automation",
    component: AllWorkflows,
    layout: "/admin",
  },
  {
    path: "/workflow/workflowLog",
    name: "Workflow Logs",
    component: WorkflowLogs,
    layout: "/admin",
  },
  {
    path: "/workflow/report",
    name: "workflow",
    component: WorkflowReport,
    layout: "/admin",
  },

  //***********Routes for Events & Signals***********//
  {
    path: "/triggersAndEvents/allTrigers",
    name: "allTrigers",
    component: AllTriggers,
    layout: "/admin",
  },

  //***********Routes for Events & Signals***********//
  {
    path: "/triggersAndEvents/createTrigger",
    name: "createTrigger",
    component: createTrigger,
    layout: "/admin",
  },
  {
    path: "/triggersAndEvents/createEvent",
    name: "createEvent",
    component: CreateEvent,
    layout: "/admin",
  },
  {
    path: "/triggersAndEvents/allEvents",
    name: "allEvents",
    component: AllEvents,
    layout: "/admin",
  },
  {
    path: "/triggersAndEvents/listEvent",
    name: "listEvent",
    component: listEvent,
    layout: "/admin",
  },
  {
    path: "/triggersAndEvents/sessionsList",
    name: "sessionsList",
    component: SessionsList,
    layout: "/admin",
  },
  {
    path: "/triggersAndEvents/SessionsUsersList",
    name: "sessionsList",
    component: SessionsUsersList,
    layout: "/admin",
  },
  {
    path: "/triggersAndEvents/PageViewsList",
    name: "PageViewsList",
    component: PageViewsList,
    layout: "/admin",
  },
  {
    path: "/triggersAndEvents/UtmlBuilder",
    name: "UtmlBuilder",
    component: UtmlBuilder,
    layout: "/admin",
  },

  //***********Routes for Apps***********//
  {
    path: "/settings/all_apps",
    name: "All Apps",
    component: AllApps,
    layout: "/admin",
  },
  {
    path: "/settings/app_config",
    name: "App Configuration",
    component: AppConfigure,
    layout: "/admin",
  },
  {
    path: "/settings/users",
    name: "settings",
    component: AllUsers,
    layout: "/admin",
  },
  {
    path: "/settings/configurations",
    name: "settings",
    layout: "/admin",
    component: Configurations
  },

  {
    path: "/settings/payments",
    name: "settings",
    layout: "/admin",
    component: Payment
  },
  {
    path: "/users/create",
    name: "users",
    component: CreateUser,
    layout: "/admin",
  },

  /*** customer journey */
  {
    path: "/goals/detail",
    name: "GoalDetails",
    component: GoalDetails,
    layout: "/admin",
  },
  {
    path: "/settings/objects",
    name: "Settings",
    component: Settings,
    layout: "/admin",
  },
  {
    path: "/sales/deals",
    name: "Sales",
    component: Deals,
    layout: "/admin",
  },
  {
    path: "/sales/dealDetail",
    name: "Sales",
    component: DealDetails,
    layout: "/admin",
  },




  {
    path: "/sales/tasks",
    name: "Tasks",
    component: Tasks,
    layout: "/admin",
  },

  {
    path: "/sales/meetings/calender",
    name: "MeetCalendar",
    component: MeetCalendar,
    layout: "/admin",
  }

];
export default dashRoutes;
